module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_vm._v("\n    Proccesing\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f0023e24!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Payment_confirm.vue
// module id = 127
// module chunks = 0